import { isPresent } from '@mbfab/shared'
import type { ReactNode } from 'react'

// 使い方のルール: docs/develop/client_ui/components/data-table.md

// 「値が無い」セルは空欄のままにせず不在を明示する（docs/develop/client_ui/components/data-table.md「列の表示」。v1 valueOrDash と同じ）。
// 発注照合テーブル（orders-table-columns.tsx）から切り出した共通部品。他の一覧テーブルも同じ表示に揃える
export function valueOrDash(value: string | number | null | undefined): ReactNode {
  return isPresent(value) ? value : <span className="text-muted-foreground">—</span>
}
